document.addEventListener("turbolinks:load", function() {
  let editor = null;

  if ( $('#recommend-search-setting-wrapper').length  ) {

    /**
     * 公開・非公開切り替え
     */
    $('#update-recommend-search-toggle').on('click', function(){
      let caller = $(this);
      caller.css('pointer-events', 'none');
      $.ajax({
        url: '/recommend_search_setting/update_recommend_search_setting_show_valid',
        type: 'post',
        dataType: 'json',
        data: {
          id: $('#recommend-search-setting-id').val(),
          show_valid: $('#recommend-search-toggle-public').prop('checked') ? 1 : 0,
        },
      })
        .done(function(data){
          if (data.ret == 0){
            alert('登録しました');
            location.reload();
          }else{
            alert(data['message']);
          }
        })
        .fail(function(){
          alert('登録に失敗しました');
        });
      caller.css('pointer-events', 'auto');
    });

    /**
     * URL行の追加ボタンイベント
     * クリックされたボタンの親要素のtableの最後のtrを複製する
     */
    $('.url-add').on('click', function(){
      let table = $(this).parent('div').first().find('table')
      let tr = table.find('tr:last').clone();
      let input = tr.find('input');
      input.val('');
      input.attr('data-id', '');
      if (tr.find('.url-del').length) {
        tr.find('.url-del').removeClass('hidden');
      }else{
        let td = $(`<td class="h-50px"><div class="url-del btn btn-outline btn-error btn-sm">削除</div></td>`);
        tr.append(td);
      }
      table.append(tr);
      resetInputRemove();
    });

    // URL行の削除ボタンイベント再設定
    function resetInputRemove(){
      $('.url-del').off().on('click', function(){
        $(this).closest('tr').remove();
      });
    }
    resetInputRemove();


    /**
     * 表示URLの保存イベント
     */
    $('#update-recommend-search-setting-url').on('click', function(){
      let caller = $(this);
      caller.css('pointer-events', 'none');
      // #urls 内のデータをオブジェクトに変換
      // - idはdata-id属性に格納
      // - valueはinput要素の値
      let urls = [];
      let urlInputs = $('#urls').find('input');
      urlInputs.each(function(index, input) {
        // urlが空 or trimで空文字になる場合はスキップ
        if ($(input).val() === '' || $(input).val().trim() === '') {
          return true;
        }
        let id = $(input).attr('data-id');
        urls.push({
          id: id,
          url: $(input).val()
        });
      });
      // POST
      $.ajax({
        url: '/recommend_search_setting/update_recommend_search_setting_url',
        type: 'post',
        dataType: 'json',
        data: {
          recommend_search_setting_id: $('#recommend-search-setting-id').val(),
          urls: urls,
        },
      })
        .done(function(data){
          if (data['result'] === 'success'){
            alert('登録しました');
            location.reload();
          }else{
            alert(data['message']);
          }
        })
        .fail(function(){
          alert('登録に失敗しました');
        });
      caller.css('pointer-events', 'auto');
    });

    /**
     * 除外URLの保存イベント
     */
    $('#update-recommend-search-setting-excluded-url').on('click', function(){
      let caller = $(this);
      caller.css('pointer-events', 'none');
      // #excluded-urls 内のデータをオブジェクトに変換
      // - idはdata-id属性に格納
      // - valueはinput要素の値
      let excludedUrls = [];
      let excludedUrlInputs = $('#excluded-urls').find('input');
      excludedUrlInputs.each(function(index, input) {
        // urlが空 or trimで空文字になる場合はスキップ
        if ($(input).val() === '' || $(input).val().trim() === '') {
          return true;
        }
        let id = $(input).attr('data-id');
        excludedUrls.push({
          id: id,
          url: $(input).val()
        });
      });
      // POST
      $.ajax({
        url: '/recommend_search_setting/update_recommend_search_setting_excluded_url',
        type: 'post',
        dataType: 'json',
        data: {
          recommend_search_setting_id: $('#recommend-search-setting-id').val(),
          urls: excludedUrls,
        },
      })
        .done(function(data){
          if (data['result'] === 'success'){
            alert('登録しました');
            location.reload();
          }else{
            alert(data['message']);
          }
        })
        .fail(function(){
          alert('登録に失敗しました');
        });
      caller.css('pointer-events', 'auto');
    });

    /**
     * 要素セレクタの保存イベント
     */
    $('#update-recommend-search-setting-selector').on('click', function(){
      let caller = $(this);
      caller.css('pointer-events', 'none');
      // POST
      $.ajax({
        url: '/recommend_search_setting/update_recommend_search_setting_selector',
        type: 'post',
        dataType: 'json',
        data: {
          recommend_search_setting_id: $('#recommend-search-setting-id').val(),
          search_element_selector: $('#search-element-selector').val(),
          append_element_selector: $('#append-element-selector').val(),
        },
      })
      .done(function(data){
        if (data['result'] === 'success'){
          alert('登録しました');
          location.reload();
        }else{
          alert(data['message']);
        }
      })
      .fail(function(){
        alert('登録に失敗しました');
      });
      caller.css('pointer-events', 'auto');
    });


    /**
     * 表示数の設定
     */
    $('#update-recommend-search-setting-count').on('click', function(){
      let caller = $(this);
      caller.css('pointer-events', 'none');
      let matchItemCount = $('#match-item-count').val();
      let recommendItemCount = $('#recommend-item-count').val();
      if (matchItemCount < 0 || matchItemCount.trim() === '') {
        alert('キーワードマッチした商品の表示数を入力してください');
        caller.css('pointer-events', 'auto');
        return false;
      }
      if (recommendItemCount < 0 || recommendItemCount.trim() === '') {
        alert('レコメンドされた商品の表示数を入力してください');
        caller.css('pointer-events', 'auto');
        return false;
      }
      // POST
      $.ajax({
        url: '/recommend_search_setting/update_recommend_search_setting_item_count',
        type: 'post',
        dataType: 'json',
        data: {
          id: $('#recommend-search-setting-id').val(),
          match_item_count: matchItemCount,
          recommend_item_count: recommendItemCount,
        },
      })
        .done(function(data){
          if (data['ret'] === 0){
            alert('登録しました');
            location.reload();
          }else{
            alert(data['message']);
          }
        })
        .fail(function(){
          alert('登録に失敗しました');
        });
      caller.css('pointer-events', 'auto');
    });


    /**
     * CSS設定画面の設定
     * aceを使用してエディタを表示
     */
    editor = ace.edit("recommend-search-css");
    editor.session.setMode("ace/mode/css");
    editor.setTheme("ace/theme/twilight");

    // タブのスペース数を設定
    editor.getSession().setTabSize(2);

    // セッションの変更時のイベントを監視
    editor.session.on('changeAnnotation', function() {
      let annotations = editor.session.getAnnotations() || [], i = len = annotations.length;
      while (i--) {
        if(/important/.test(annotations[i].text)) { // !importantに関する警告をチェック
          annotations.splice(i, 1);
        }
      }
      if (len > annotations.length) {
        editor.session.setAnnotations(annotations);
      }
    });

    $('#update-recommend-search-css').on('click', function () {
      let caller = $(this);
      caller.css('pointer-events', 'none');
      let cssVal = editor.getValue();

      $.ajax({
        url: 'recommend_search_setting/update_css_property',
        type: 'POST',
        data: {
          id: $('#recommend-search-setting-id').val(),
          css_val: cssVal,
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == 0) {
          if (data.message!='') {
            alert(data.message);
          } else {
            alert('登録しました');
          }
          location.reload();
        } else {
          alert(data.message);
        }
      })
      .fail(function(){
        alert('登録に失敗しました');
      });
      caller.css('pointer-events', 'auto');
    });


    /**
     * 汎用的な保存イベントのテスト
     * 要素のdata-*属性にルールを適応
     * - data-type: "form" ... データ収集の起点となる親要素とする
     * - data-type: "submit" ... クリックイベントを設定する対象
     * - data-type: "column" ... 保存対象の要素に設定。data-column属性に保存するカラム名を格納
     * - data-column: "column_name" ... 保存するカラム名
     * - data-validation: "hoge fuga" ... バリデーションルールを指定。半角スペースで区切ることで複数指定可能
     * ユースケース
     * 1. data-type="submit"の要素をクリック
     * 2. 1の一番近い親要素（data-type="form"）を取得
     * 3. 2の子要素のうちdata-type="column"の要素を取得
     * 4. 3の要素のdata-column属性の値をカラム名として、dataをPOSTする
     */
    function updateAttribute() {
      let caller = $(this);
      caller.css('pointer-events', 'none');
      let parentElement = caller.closest('[data-type="form"]');
      let data = {};
      let inputs = parentElement.find('[data-type="column"]');
      inputs.each(function(index, input) {
        let column = $(input).data('column');
        let value = $(input).val();
        data[column] = value;
      });
      $.ajax({
        url: caller.attr('data-url'),
        type: 'post',
        dataType: 'json',
        data: {
          id: $('#recommend-search-setting-id').val(),
          data: data
        },
      })
        .done(function(data){
          if (data['result'] === 'success'){
            alert('登録しました');
            location.reload();
          }else{
            alert(data['message']);
          }
        })
        .fail(function(){
          alert('登録に失敗しました');
        });
      caller.css('pointer-events', 'auto');
    }
    // 登録ボタンのイベント設定
    $('[data-type="submit"]').on('click', updateAttribute);


    /**
     * バリデーションルール定義
     * @param targetElement {HTMLElement} - バリデーションを設定する要素
     * @param rule {string} - バリデーションの種類
     */
    function validation(targetElement, rule) {
      // スペースでsplitして複数指定にも対応させる
      let rules = rule.split(' ');
      rules.each(function(index, rule) {
        switch (rule) {
          case 'required':
            if (targetElement.val() === '' || targetElement.val().trim() === '' || targetElement.val() === null || targetElement.val() === undefined) {
              alert('必須項目です');
              return false;
            }
            break;

          default:
            break;
        }
      });
    }


  } // page check end
});
